<div class="empty-data" [class.--display]="display">
    <p class="--p1" [innerHTML]="text"></p>
</div>
